module.exports = __webpack_public_path__ + "static/img/b51.185d7f8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/b51.png
// module id = o3tn
// module chunks = 0